// DUPLICATED from packages/frontend for the studio (intentional — see
// docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
// Keep rendering in sync with the frontend original when it changes.
import { GrandAlliance } from '@scrolldex/shared';

export function allianceIcon(alliance: string): string {
  switch (alliance.toUpperCase()) {
    case GrandAlliance.ORDER:
      return 'crown';
    case GrandAlliance.CHAOS:
      return 'link';
    case GrandAlliance.DESTRUCTION:
      return 'fist-raised';
    case GrandAlliance.DEATH:
      return 'ghost';
    default:
      return 'flag';
  }
}

export const ICON_REGIMENTS_OF_RENOWN = 'users';
export const ICON_MANIFESTATIONS = 'hand-sparkles';
export const ICON_PATH_TO_GLORY = 'map';
